import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModalWithTimer } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { INCREASE_LIMITS_DOCUMENTS_SUBMITTED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AUTH_PROFILE_LIMITS } from 'apps/auth/constants/UrlConstants';
import { useExtra } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const KYCOnfidoStatus = (props) => {
    const { linkToSend } = useExtra();

    useEffect(() => {
        if (props.status === 'success') {
            amplitude.getInstance().logEvent(INCREASE_LIMITS_DOCUMENTS_SUBMITTED);
        }
    }, []);
    const renderText = (text = '') => {
        return MarkdownService.splitByParagraph(text || '', [], { color: 'secondary' });
    };

    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName={props.status !== 'fail' ? 'clock-80' : ''}
                iconColor={props.status !== 'fail' ? 'primary' : ''}
                animatedIconFail={props.status === 'fail'}
                headerText={<DangerouslyHtml sanitizeAllHtmlTags dangerouslyHtml={props.screenTitle} />}
                secondaryText={renderText(props.text)}
                primaryButtonCaption={props.gotItButton}
                primaryButtonType="link"
                primaryButtonLink={linkToSend || AUTH_PROFILE_LIMITS}
                primaryButtonOnClick={(e) => {
                    if (props.linkAfterModal) {
                        e.preventDefault();
                        props.toggleModalWithTimer(true, props.getIbanAfterReview, () => (window.location = props.linkAfterModal));
                    }
                }}
            />
        </BaseLayout>
    );
};

const mapStateToProps = ({ extra, messages: { pageMessages } }) => ({
    status: extra.status,
    linkAfterModal: extra.linkAfterModal,
    getIbanAfterReview: pageMessages.getIbanAfterReview,
    screenTitle: pageMessages.screenTitle,
    text: pageMessages.screenText,
    gotItButton: pageMessages.emailCheckInboxGotItButton,
});
export default connect(mapStateToProps, { toggleModalWithTimer })(BasePage(KYCOnfidoStatus));
